export const ExpandIcon = ({
  width = 17,
  height = 10,
  color = '#64666A',
}: {
  width?: number;
  height?: number;
  color?: string;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M8.49937 9.6262L0.960938 2.0878L2.19937 0.849365L8.49937 7.14937L14.7994 0.849365L16.0378 2.0878L8.49937 9.6262Z"
      fill={color}
    />
  </svg>
);
